//
export default [
    {
        name: 'is_pyme',
        type: 'select',
        props: {
            chips: true,
            items: [
                {
                    text: 'Si',
                    value: 1,
                },
                {
                    text: 'No',
                    value: 0,
                },
            ],
            label: 'Pyme',
            noObject: true,
        },
    },
    {
        name: 'rut',
        type: 'text-field',
        props: {
            label: 'Rut',
        },
    },
    {
        name: 'business_name',
        type: 'text-field',
        props: {
            label: 'Razon social',
        },
    },
    {
        name: 'alias_name',
        type: 'text-field',
        props: {
            label: 'Nombre',
        },
    },
]